import { API } from "@/services/api";
import { IAPIResponse } from "@/services/api.types";
import { notificationEndpoints } from "@/constant/endpoints";
import { buildQueryString } from "@/utils/common.utils";
import {
  MarkReadPayload,
  NotificationsParams,
  NotificationsResponse,
} from "@/types/notifications.types";

export const getNotificationsService = async (
  params: NotificationsParams = {}
): Promise<NotificationsResponse> => {
  const response = await API.Get<NotificationsResponse>(
    `${notificationEndpoints.list}${buildQueryString(params)}`
  );
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const markNotificationsReadService = async (
  payload: MarkReadPayload
): Promise<IAPIResponse<{ updated: number }>> =>
  API.Patch<MarkReadPayload, { updated: number }>(notificationEndpoints.markRead, payload);
